import { useState } from "react";
import "../styles/Shop.css";

const discountRanges = [
  { label: "0–10%", min: 0, max: 10 },
  ...Array.from({ length: 7 }, (_, index) => {
    const min = (index + 1) * 10;
    return { label: `${min + 1}–${min + 10}%`, min, max: min + 10 };
  }),
];

function FilterPanel({ filters, onOpenChange }) {
  const [isOpen, setIsOpen] = useState(false);

  const togglePanel = () => {
    setIsOpen((previous) => {
      const nextIsOpen = !previous;
      onOpenChange?.(nextIsOpen);
      return nextIsOpen;
    });
  };
  const {
    selectedSubcategory,
    setSelectedSubcategory,

    selectedBrands,
    setSelectedBrands,

    maxPrice,
    setMaxPrice,

    priceLimit,

    selectedDiscountRange,
    setSelectedDiscountRange,

    minRating,
    setMinRating,

    uniqueBrands,

    subcategories = [],

    displayMaxPrice,
    clearFilters,
  } = filters;

  return (
    <div className={`filter-panel ${isOpen ? "is-open" : ""}`}>
      <button
        type="button"
        className="filter-trigger"
        onClick={togglePanel}
        aria-expanded={isOpen}
      >
        Filters
      </button>

      {isOpen && (
          <aside className="filter-drawer" aria-label="Filters">
            <div className="filter-drawer-header">
              <h3>Filters</h3>
            </div>
            <div className="filters">
      {/* <h3>Product Categories</h3>

      <ul className="category-list">
        {categories.map((c, i) => (
          <li
            key={i}
            className={selectedCategory === c.name ? "active" : ""}
            onClick={() => setSelectedCategory(c.name)}
          >
            <span>{c.name}</span>
            <span className="category-count">({c.count})</span>
          </li>
        ))}
      </ul> */}

      <h3>Subcategories</h3>

      <ul className="subcategory" style={{ fontSize: "13px", marginBottom: "16px", marginLeft: 0, listStyleType: "none" }}>
        {subcategories.map((sc) => (
          <li key={sc.name} className={selectedSubcategory.includes(sc.name) ? "active" : ""}>
          <label style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>
            <input
              type="checkbox"
              checked={selectedSubcategory.includes(sc.name)}
              onChange={(event) => {
                setSelectedSubcategory((previous) =>
                  event.target.checked
                    ? [...previous, sc.name]
                    : previous.filter((name) => name !== sc.name),
                );
              }}
            />
            <span>{sc.name}</span>
            <span className="category-count">({sc.count})</span>
          </label>
          </li>
        ))}
      </ul>

      <div className="price-filter">
        <h4>Filter By Price</h4>

        <div className="price-range">
          <span>Up to ₹{displayMaxPrice.toFixed(2)}</span>
        </div>

        <input
          type="range"
          className="price-slider"
          min="0"
          max={priceLimit}
          step="10"
          value={maxPrice}
          onChange={(e) => setMaxPrice(Number(e.target.value))}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <h4>Filter By Brand</h4>

        {uniqueBrands?.map((brand) => (
          <label key={brand}>
            <input
              type="checkbox"
              style={{ marginRight: 10 }}
              checked={selectedBrands.includes(brand)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedBrands((prev) => [...prev, brand]);
                } else {
                  setSelectedBrands((prev) =>
                    prev.filter((b) => b !== brand)
                  );
                }
              }}
            />
            {brand}
          </label>
        ))}
      </div>

      <div className="discount-filter">
        <h4>Filter By Discount</h4>
        <select
          value={selectedDiscountRange ? `${selectedDiscountRange.min}-${selectedDiscountRange.max}` : ""}
          onChange={(event) => {
            const range = discountRanges.find(
              (item) => `${item.min}-${item.max}` === event.target.value,
            );
            setSelectedDiscountRange(range || null);
          }}
          style={{
            width: "100%",
            padding: "6px 10px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontSize: "14px",
            cursor: "pointer",
          }}
        >
          <option value="">All discounts</option>
          {discountRanges.map((range) => (
            <option key={range.label} value={`${range.min}-${range.max}`}>
              {range.label}
            </option>
          ))}
        </select>
      </div>

      <div className="rating-filter">
        <h4>Filter By Rating</h4>
        <select
          value={minRating}
          onChange={(e) => setMinRating(Number(e.target.value))}
          style={{
            width: "100%",
            padding: "6px 10px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontSize: "14px",
            cursor: "pointer",
          }}
        >
          <option value={0}>All Ratings</option>
          <option value={1}>1 Star & above</option>
          <option value={2}>2 Stars & above</option>
          <option value={3}>3 Stars & above</option>
          <option value={4}>4 Stars & above</option>
          <option value={5}>5 Stars only</option>
        </select>
      </div>

      <button
        className="clear-filters"
        onClick={() => {
          clearFilters();
          setIsOpen(false);
          onOpenChange?.(false);
        }}
      >
        Clear All Filters
      </button>
            </div>
          </aside>
      )}
    </div>
  );
}

export default FilterPanel;
